<h6 class="font-xxs font-regular margin-0 sparro-grey-800" *ngIf="publication?.disciplines?.length">
  <a [href]="goToTopic(publication.disciplines[0].slug)" class="no-decor-hover" > {{ publication.disciplines[0].name | titlecase }} </a>
</h6>

<div *ngIf="footerType === 'score'">
  <div fxLayout="row" fxLayoutAlign="start center" class="height-100 padding-bottom-1">
    <ng-container *ngIf="publication.evaluation_score; else noEvalScore">
      <h6 class="font-bold margin-0 sparro-yellow-800" style="font-size:16px;" [ngClass]="{'sparro-green-600': publication.evaluated }">
        Score: {{ publication.evaluation_score }}
      </h6>
    </ng-container>

    <ng-template #noEvalScore>
      <h6 class="font-bold sparro-orange-800 margin-0" style="font-size:16px;">
        Score: N/E
      </h6>
    </ng-template>
  </div>
</div>

<div *ngIf="footerType === 'none'">

</div>
